import * as React from 'react';
import Link from '@src/components/link';
import FloatRightStore from './store';
import wrapStore from '@src/utils/wrap-store';
import cx from 'classnames';
import { handleDownloadLinkClick } from '@src/utils/download-link';
import $$tracker from '@src/tracker';

const styles = require('./index.less');

const ChannelLinks = () => (
  <div className={styles.follows}>
    <button type="button" className={cx(styles.channel, styles.wx)} aria-label="查看微信公众号二维码">
      <span className={cx(styles.hoverOpenQrcode, styles.hoverOpenQrcodeWx)}>
        <img src={require('./images/qrcode-wx.jpg')} alt="微信公众号二维码" />
      </span>
    </button>
    <button type="button" className={cx(styles.channel, styles.qw)} aria-label="查看官方客服二维码">
      <span className={cx(styles.hoverOpenQrcode, styles.hoverOpenQrcodeQw)}>
        <img src={require('./images/qrcode-qw.jpg')} alt="官方客服二维码" />
      </span>
    </button>
  </div>
);

const FloatRight = ({ store }) => {
  store.use();

  return (
    <div className={cx(styles.root, store.show && styles.show)}>
      {store.isOpen && (
        <div className={cx(styles.floatRight, store.type === 2 && styles.floatRightType2)}>
          {store.type === 1 && <ChannelLinks />}
          {store.type === 2 && (
            <React.Fragment>
              <div className={styles.qrcodeBox}>
                {store.downloadUrl.floatQrcode && <iframe src={store.downloadUrl.floatQrcode} title="首页侧边扫码下载游戏" />}
              </div>
              <div className={styles.downloadTitle}>扫码下载游戏</div>
              <div className={styles.download}>
                {Object.keys(store.download).map(key => {
                  const downloadLink = store.downloadUrl[store.download[key].url];
                  return (
                    <Link
                      key={key}
                      className={cx(styles.downloadBtn, styles[key])}
                      href={downloadLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={store.download[key].name}
                      onClick={event =>
                        handleDownloadLinkClick(event, downloadLink, () => {
                          if (key === 'android') $$tracker.clickDownloadAndroid('首页侧边');
                          if (key === 'ios') $$tracker.clickDownloadIOS('首页侧边');
                        })
                      }
                    />
                  );
                })}
              </div>
              <ChannelLinks />
            </React.Fragment>
          )}
          <button type="button" className={styles.topbtn} onClick={store.backToTop} aria-label="返回顶部" />
          {/* {store.type === 2 && (
            <div className={styles.download}>
              {Object.keys(store.download).map(key => (
                <Link key={key} className={cx(styles.downloadBtn, styles[key])} href={store.downloadUrl[store.download[key].url]} target="_blank" />
              ))}
            </div>
          )} */}

          {/* <div className={styles.btns}>
            <div className={cx(styles.channel, styles.wx)}>
              <div className={styles.hoverOpenQrcode}>
                <img src={require('./images/qrcode-wx.jpg')} alt="" />
              </div>
            </div>
            <div className={cx(styles.channel, styles.qw)}>
              <div className={styles.hoverOpenQrcode}>
                <img src={require('./images/qrcode-qw.jpg')} alt="" />
              </div>
            </div>
          </div> */}
          {/* <Link className={styles.close} onClick={() => store.changeOpen(false)} /> */}
        </div>
      )}
      {/* {!store.isOpen && <Link className={styles.open} onClick={() => store.changeOpen(true)} />} */}
    </div>
  );
};

export default wrapStore(FloatRight, FloatRightStore);
